import __request__ from "routing/request";
export function list() {
  return __request__("GET", "/system/inputstates", null, {}, {
    "Accept": ["application/json"]
  });
}
export function setup(inputId) {
  return __request__("PUT", `/system/inputstates/setup/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function get(inputId) {
  return __request__("GET", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function start(inputId) {
  return __request__("PUT", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function stop(inputId) {
  return __request__("DELETE", `/system/inputstates/${inputId}`, null, {}, {
    "Accept": ["application/json"]
  });
}
